export default
{
	availableUnits: 10,
	score: {
		min: 4,
		max: 8,
        displayMax: 11
	},
	name: "delier5",
	day: 3,
	date: {
		time: "09:33",
		day: "scene.date.text"
	},
	patientState: 0,
	delirium: {
		initialState: "groen",
		clockPosition: {
			x: 777,
			y: 191
		},
		videoUrls: [
			{
				whiteboardState: 0,
				blindsState: 0,
				url: "delier5/${locale}/delier_5_nacht_ochtend_blinds-dicht.flv"
			},
			{
				whiteboardState: 1,
				blindsState: 0,
				url: "delier5/${locale}/delier_5_nacht_ochtend_blinds-dicht_ma.flv"
			},
			{
				whiteboardState: 2,
				blindsState: 0,
				url: "delier5/${locale}/delier_5_nacht_ochtend_blinds-dicht_di.flv"
			},
			{
				whiteboardState: 3,
				blindsState: 0,
				url: "delier5/${locale}/delier_5_nacht_ochtend_blinds-dicht_wo.flv"
			}
			
		],
		roomViewToggleButtonPosition: {
			x: 1171,
			y: 262
		}
	},
	room: {
		backgroundImage: {
			blindsOpenUrl: "delier5/delier5_nurseview_room_blinds_open.jpg",
			blindsClosedUrl: "delier5/delier5_nurseview_room_blinds_closed.jpg"
		},
		clock: {
			blindsOpenUrl: "delier5/delier5_nurseview_room_blinds_open_klok.png",
			blindsClosedUrl: "delier5/delier5_nurseview_room_blinds_closed_klok.png"
		}
	},
	end: {
		clockPosition: {
			x: 784,
			y: 184
		},
		videoUrls: [
			{
				whiteboardState: 0,
				blindsState: 0,
				url: "delier5/${locale}/delier_5_slot_blinds_dicht.flv"
			},
			{
				whiteboardState: 1,
				blindsState: 0,
				url: "delier5/${locale}/delier_5_slot_blinds_dicht_ma.flv"
			},
			{
				whiteboardState: 2,
				blindsState: 0,
				url: "delier5/${locale}/delier_5_slot_blinds_dicht_di.flv"
			},
			{
				whiteboardState: 3,
				blindsState: 0,
				url: "delier5/${locale}/delier_5_slot_blinds_dicht_wo.flv"
			},
			{
				whiteboardState: 4,
				blindsState: 0,
				url: "delier5/${locale}/delier_5_slot_blinds_dicht_do.flv"
			},
			{
				whiteboardState: 0,
				blindsState: 1,
				url: "delier5/${locale}/delier_5_slot_blinds_open.flv"
			},
			{
				whiteboardState: 1,
				blindsState: 1,
				url: "delier5/${locale}/delier_5_slot_blinds_open_ma.flv"
			},
			{
				whiteboardState: 2,
				blindsState: 1,
				url: "delier5/${locale}/delier_5_slot_blinds_open_di.flv"
			},
			{
				whiteboardState: 3,
				blindsState: 1,
				url: "delier5/${locale}/delier_5_slot_blinds_open_wo.flv"
			},
			{
				whiteboardState: 4,
				blindsState: 1,
				url: "delier5/${locale}/delier_5_slot_blinds_open_do.flv"
			}
		]
	},
	transitions: [
		{
			deliriumState: "wit",
			target: "evaluation"
		},
		{
			deliriumState: "groen",
			target: "evaluation"
		},
		{
			deliriumState: "oranje",
			target: "evaluation"
		}
	],
	mediaUrls: [
		{
			categoryName: "communiceren",
			value: "delier5/${locale}/delier_5_dialoog_startloop.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "patientvragennaarnachtrust",
			value: "delier5/${locale}/delier_5_dialoog_doorvrhallucinatie.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "afrondenenkamerverlaten",
			value: "delier5/${locale}/delier_5_dialoog_dag.flv"
		}
	]
}